export default __webpack_public_path__ + "static/media/register_pc.6642f774.svg";